import { useEffect, useRef, useState } from "react";

const CountUpOnView = ({ target, duration = 2000 }) => {
  const ref = useRef(null);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let observer;
    let interval;

    observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;

      let start = 0;
      const steps = 50;
      const increment = Math.ceil(target / steps);
      const delay = duration / steps;

      interval = setInterval(() => {
        start += increment;
        if (start >= target) {
          setValue(target);
          clearInterval(interval);
        } else {
          setValue(start);
        }
      }, delay);

      observer.disconnect();
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [target, duration]);

  return (
    <span ref={ref} className="count">
      {value}
    </span>
  );
};

export default CountUpOnView;